//* Libraries imports
import { Suspense } from "react";

//* Components imports
import { Content } from "../list/_components";

export default function ProcessList() {
  return (
    <div className="row">
      <Suspense>
        <Content />
      </Suspense>
    </div>
  );
}
